module.exports = __webpack_public_path__ + "img/hurray.1eebacf9.svg";